export const ENTITY_TYPE_DATA_KEY = 'entityType'
export const ENTITY_MODEL = 'entityModel'
